import React from 'react';

function ContactUs () {
  return (
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLSfIk-WonjaYgv12jRNrWAXewi74b327rPpLKcMFOeg8j9sS1w/viewform?embedded=true"
      title="Contact Us"
      width="100%"
      height="750"
      frameborder="0"
      marginheight="0"
      marginwidth="0"
    >
      Loading…
    </iframe>
  );
}

export default ContactUs;
